import { postPrayerSchema } from "../../../lib";
import { useRequestMutation } from "../../../request";

export const useRequestPostPrayer = () => {
  return {
    query: useRequestMutation<
      typeof postPrayerSchema,
      { type: "app-open" | "queue-completion" }
    >({
      mutationFnRequestProps: ({ type }) => ({
        method: "GET",
        urlBackendPath: `/me/postprayer/v3?type=${type}`,
        schema: postPrayerSchema,
      }),
    }),
  };
};
